import http from '../http'
// 获取工作内容数据
export const getPatrolDeployListForApp = data => {
    return http(`/app-api/info/rule-permission/getPatrolDeployListForApp?projectId=${data.projectId}&module=patrol`, 'get', data)
}
// 获取设备数据
export const getEvaEquTypeList = data => {
    return http(`/app-api/info/rule-permission/getEvaEquTypeList?deployId=${data.deployId}`, 'get', data)
}

//工程名称等信息
export const get_project = data => {
    return http(`/app-api/app/inspection-prj/get-project?id=${data.id}`, 'get', data)
}

//巡检发布页选择人员
export const getMemberlist = data => {
    return http(`/app-api/info/rule-permission/getMemberUsers`, 'get', data, true)
}

export const getEvaMemberUsers = data => {
    return http(`/app-api/info/rule-permission/getEvaMemberUsers`, 'get', data, true)
}

//巡检列表页选择设备
export const getEquTypeListByInfo = data => {
    return http(`/app-api/info/rule-permission/getEvaEquTypeListByInfo`, 'get', data, true)
}



//巡检列表检查人员上传
export const synMemupdate = data => {
    return http(`/app-api/eva/info/basic/update`, 'post', data)
}

//巡检选择设备列表数据
export const getSubInstallPos = data => {
    return http(`/app-api/eva/info-sub/getSubInstallPos`, 'get', data, true)
}

export const getJsonProblemList = data => {
    return http(`/app-api/eva/info-sub/getJsonProblemList`, 'get', data, true)
}

//巡检设备列表数据
export const getSubInstalList = data => {
    return http(`/app-api/eva/info-sub/getSubPosDetail`, 'get', data, true)
}

//只读巡检设备所有选中列表数据
export const getAllSubPosDetail = data => {
    return http(`/app-api/eva/info-sub/getAllSubPosDetail`, 'get', data, true)
}

//只读所有动态信息tab栏渲染
export const getAllDevice = data => {
    return http(`/app-api/eva/info-sub-device/getAllDevice`, 'get', data, true)
}

//动态信息tab栏渲染
export const getDevice = data => {
    return http(`/app-api/eva/info-sub-device/getDevice`, 'get', data, true)
}

//动态信息tab栏渲染实体部分
export const getTabList = data => {
    return http(`/app-api/eva/info-sub/getTabList`, 'get', data, true)
}

//动态信息tab栏渲染管理行为和其它
export const getTabListForOther = data => {
    return http(`/app-api/eva/info-sub/getTabListForOther`, 'get', data, true)
}

//设备概况数据
export const getdevicedetail = data => {
    return http(`/app-api/eva/info-problem/get-device-detail`, 'get', data, true)
}



//动态信息数据
export const getJsonActiveList = data => {
    return http(`/app-api/eva/info-sub/getJsonActiveList`, 'get', data, true)
}

//动态信息列表输入框渲染
export const getsetactive = data => {
    return http(`/app-api/eva/info-active/get-set-active`, 'get', data, true)
}

//只读页面结论建议所有人数据
export const getSubByInfoId = data => {
    return http(`/app-api/eva/info-sub/getSubByInfoId`, 'get', data, true)
}



//动态信息上传
export const updatebatch = data => {
    return http("/app-api/eva/info-active/update", 'post', data)
}


//巡检内容基本检查项数据
export const getsetproblem = data => {
    return http("/app-api/eva/info-problem/get-set-problem", 'get', data, true)
}

//评价获取拍照水印
export const getInfoBySubDeviceId = data => {
    return http("/app-api/eva/info-sub/getInfoBySubDeviceId", 'get', data, true)
}



//巡检内容上传数据
export const maintenanceUpdateInfoProblemList = data => {
    return http("/app-api/eva/info-problem/update-batch", 'post', data)
}

//结论备注…导入获取
export const getNoteByType = data => {
    return http("/app-api/eva/info-sub/getNoteByType", 'get', data, true)
}

//其它检查项获取数据
export const getotheritem = data => {
    return http("/app-api/eva/info-problem/get-other-item", 'get', data, true)
}

//其它检查项添加问题
export const getsetotheritem = data => {
    return http("/app-api/eva/info-problem/get-set-other-item", 'get', data, true)
}

//巡检tab栏完成查询
export const checkSubDetail = data => {
    return http("/app-api/eva/info-sub/checkSubDetail", 'get', data, true)
}

//问题描述
export const getproblemdescription = data => {
    return http("/app-api/eva/info-problem/get-problem-description", 'get', data, true)
}
//风险备注
export const getriskremark = data => {
    return http("/app-api/eva/info-problem/get-risk-remark", 'get', data, true)
}

//备注建议
export const getnote = data => {
    return http("/app-api/eva/info-problem/get-note", 'get', data, true)
}

//派发
export const distributeUpData = data => {
    return http(`/app-api/eva/info/basic/create`, 'post', data)
}

//工程概况数据
export const getSubBySubId = data => {
    return http(`/app-api/eva/info-sub/getSubBySubId?subId=${data.subId}`, 'get', data)
}

//巡检完成
export const checkSubData = data => {
    return http(`/app-api/eva/info-sub/checkSubData`, 'get', data, true)
}

//结论建议 获取结论建议列表
export const getNotifyNoteByInfoId = data => {
    return http(`/app-api/eva/info/basic/getNotifyNoteByInfoId?infoId=${data.infoId}`, 'get', data)
}
//结论建议页面 上传
export const notifyNoteUpdate = data => {
    return http(`/app-api/eva/info-sub/update`, 'post', data)
}
//结论建议页面 获取
export const getsubsignface = data => {
    return http(`/app-api/eva/info-sub/get-sub-sign-face?id=${data.id}`, 'get', data)
}

//获取待处理
export const getListByStatus = data => {
    return http(`/app-api/eva/info-sub/getListByStatus`, 'get', data, true)
}


//获取我发布
export const getIaunchPageList = data => {
    return http(`/app-api/eva/info-sub/getListByInfoMe`, 'get', data, true)
}
//获取我参与

export const getListByMe = data => {
    return http(`/app-api/eva/info-sub/getListByMe`, 'get', data, true)
}

export const getListByManage = data => {
    return http(`/app-api/eva/info-sub/getListByManage`, 'get', data, true)
}

export const getPageByManage = data => {
    return http(`/app-api/eva/info-sub/getPageByManage`, 'get', data, true)
}

//获取人员操作详情
export const getListByInfoId = data => {
    return http(`/app-api/eva/info-sub/getListByInfoId?infoId=${data.infoId}`, 'get', data)
}

//根据人员操作记录查看详情

export const getOneBySubId = data => {
    return http(`/app-api/eva/info-sub/getOneBySubId?subId=${data.subId}`, 'get', data)
}

//人员操作详情最终完成
export const updatecomplete = data => {
    return http(`/app-api/eva/info/basic/update-complete`, 'get', data, true)
}

// 结论建议 选择停机设备时上传
export const shutdownDevice = data => {
    return http(`/app-api/eva/info-sub-device/shutdown-device`, 'post', data)
}


// 只读页 拿所有人员结论建议

export const getSubAllResult = data => {
    return http(`/app-api/eva/info-sub/get-all-sub-result?infoId=${data.infoId}`, 'get', data)
}

// 获取生成文档列表

export const getReportById = data => {
    return http(`/admin-api/eva/deploy-report/getReportById?infoId=${data.infoId}`, 'get', data)
}

// 获取子单数据源
export const getSubDoneByInfoId = data => {
    return http(`/app-api/eva/info-sub/getSubDoneByInfoId?infoId=${data.infoId}`, 'get', data)
}

// 生成文档

export const insertExportBatchByInfoId = data => {
    return http(`/admin-api/eva/deploy-report/insertExportBatchByInfoId`, 'post', data)
}


export const update = data => {
    return http(`/app-api/eva/info-sub/update`, 'post', data)
}

// 获取下载列表
export const getExportReportListByInfoId = data => {
    return http(`/app-api/eva/export-report/getExportReportListByInfoId?infoId=${data.infoId}`, 'get', data)
}

// 停机设备汇总列表
export const getShutDownDevice = data => {
    return http(`/app-api/eva/info-sub-device/getShutDownDevice?infoId=${data.infoId}`, 'get', data)
}
// // 结论建议汇总列表
// export const getSubByInfoId = data => {
//     return http(`/app-api/patrol/info-sub/getSubByInfoId?infoId=${data.infoId}`, 'get', data)
// }
// 闭单
export const complete = data => {
    return http(`/app-api/eva/info/basic/complete`, 'post', data)
}

//其他文件 新增

export const otherDocumentsCreate = data => {
    return http(`/app-api/eva/info-other-documents/create`, 'post', data)
}

// 其他文件 修改

export const otherDocumentsUpdate = data => {
    return http(`/app-api/eva/info-other-documents/update`, 'post', data)
}
// 其他文件 获取
export const otherDocumentsGetList = data => {
    return http(`/app-api/eva/info-other-documents/getList?evaInfoId=${data.evaInfoId}`, 'get', data)
}

// 其他文件 获取
export const otherDocumentsGet = data => {
    return http(`/app-api/eva/info-other-documents/get?id=${data.id}`, 'get', data)
}

// 其他文件 删除
export const otherDocumentsDelete = data => {
    return http(`/app-api/eva/info-other-documents/delete?id=${data.id}`, 'delete', data)
}

//删除其它问题
export const deleteissueapi = data => {
    return http(`/app-api/eva/info-problem/delete?problemId=${data.problemId}`, 'delete', data)
}
// 闭单撤回
export const patrolRevocation = data => {
    return http(`/app-api/eva/info/basic/revocation`, 'put', data, true)
}


//结论建议新增建议
export const createinfonote = data => {
    return http(`/app-api/eva/info-note/create?SubId=${data.SubId}`, 'post', data)
}


//新增建议列表获取
export const infonotegetList = data => {
    return http(`/app-api/eva/info-note/getList`, 'get', data, true)
}


//结论建议删除
export const deleteinfonote = data => {
    return http(`/app-api/eva/info-note/delete?id=${data.id}`, 'delete', data)
}


//结论建议新增建议
export const infonoteupdate = data => {
    return http(`/app-api/eva/info-note/update`, 'post', data)
}



//闭单获取结论汇总
export const getAllNoteByInfoId = data => {
    return http(`/app-api/eva/info-sub/getAllNoteByInfoId`, 'get', data, true)
}



//闭单获取结论汇总
export const individualEquAmend = data => {
    return http(`/app-api/eva/info-problem/individualEquAmend`, 'get', data, true)
}

//长按删除
export const deletePending = data => {
    return http(`/app-api/eva/info/basic/delete-info?infoId=${data.infoId}`, 'get', data)
}
// 复查 -- 选择人员列表
export const copyEva = data => {
    return http(`/app-api/eva/info/basic/recheck-leader-list?infoId=${data.infoId}`, 'get', data)
}
// 复查 -- 确认人员并发布
export const confirmPerson = data => {
    return http(`/app-api/eva/info/basic/recheck-publish`, 'get', data, true)
}
